import http from 'hub-http/clients/apiClient';
const USER_TIMEZONES_API_BASE_URL = 'user-timezones/v1';
export default class UserTimezonesApi {}
UserTimezonesApi.moment = timezoneId => {
  return http.get(`${USER_TIMEZONES_API_BASE_URL}/moment/`, {
    query: {
      'timezone-id': timezoneId
    }
  });
};